import { popModal } from '..';

export type CreateAgendaSlotBulkReportModalApi = {
  onClose?: () => void;
};

export const useCreateAgendaSlotBulkReportModalApiViewModel = ({
  api,
}: {
  api: CreateAgendaSlotBulkReportModalApi;
}) => {
  const closeAddDcotor = () => {
    popModal('CreateAgendaSlotBulkReportModal');
    api.onClose?.();
  };

  return {
    api: {
      close: closeAddDcotor,
    },
  };
};

export type CreateAgendaSlotBulkReportModalApiViewModel = ReturnType<
  typeof useCreateAgendaSlotBulkReportModalApiViewModel
>;
